﻿import { mapGetters, mapState } from 'vuex';

module.exports = {
    name: 'mini-basket',
    template: '#mini-basket-template',
    props: ['blockid'],
    data: () => ({
        showModal: false
    }),
    mounted: function () {
        this.$store.dispatch('registerBasket', { id: this.blockid })
    },
    computed:
     Object.assign(
        mapState({
            basket: state => state.checkout.basket.content
        }),
        {
        isNotEmpty() {
            return this.basket && this.basket.cartItemGroups && this.basket.cartItemGroups.length;
        },
        cartItems() {
            if(!this.basket || !this.basket.cartItemGroups) return [];

            let items = [];

            for (let i = 0; i < this.basket.cartItemGroups.length; i++) {
                for (let j = 0; j < this.basket.cartItemGroups[i].cartItems.length; j++) {
                    let mItem = this.basket.cartItemGroups[i].cartItems[j];

                    if (!mItem.hasCampaign && (mItem.monthlyPrice || mItem.monthlyPrice == 0)) {
                        items.push(mItem);
                    }
                }
            }
            return items;
        },
        groupedCartItems() {
            if(!this.basket || !this.basket.cartItemGroups) return [];

            let items = [];

            for (let i = 0; i < this.basket.cartItemGroups.length; i++) {
                for (let j = 0; j < this.basket.cartItemGroups[i].cartItems.length; j++) {
                    let mItem = this.basket.cartItemGroups[i].cartItems[j];
                    if (!mItem.hasCampaign && (mItem.monthlyPrice || mItem.monthlyPrice == 0)) {
                        items.push(mItem);
                    }
                }
            }
            return this.groupBy(items, 'categoryName');
        },
        groupedCartItemsNonRecurring() {
            let groups = [];
            if(!this.basket || !this.basket.cartItemGroups) return [];

            let items = [];

            for (let i = 0; i < this.basket.cartItemGroups.length; i++) {
                for (let j = 0; j < this.basket.cartItemGroups[i].cartItems.length; j++) {
                    let mItem = this.basket.cartItemGroups[i].cartItems[j];
                    if (!mItem.hasCampaign && (mItem.priceUpFront || mItem.priceUpFront == 0)) {
                        items.push(mItem);
                    }
                }
            }

            return this.groupBy(items, 'categoryName');
        },
        groupedCartItemsCampaigns() {
            let groups = [];
            if (!this.basket || !this.basket.cartItemGroups) return [];

            let items = [];

            for (let i = 0; i < this.basket.cartItemGroups.length; i++) {
                for (let j = 0; j < this.basket.cartItemGroups[i].cartItems.length; j++) {
                    let mItem = this.basket.cartItemGroups[i].cartItems[j];
                    if (mItem.hasCampaign === true) {
                        items.push(mItem);
                    }
                }
            }

            return this.groupBy(items, 'categoryName');
        },
        monthlyTotal() {
            if (!this.basket || !this.basket.cartItemGroups) {
                return 0;
            } else {
                return this.basket.cartItemGroups[0].monthlyTotalPrice;
            }
            
        },
        grandTotal() {
            if(!this.basket || !this.basket.cartItemGroups) return 0;
            return this.basket.cartItemGroups[0].totalGrandPrice;
        },
        upFrontTotal() {
            if(!this.basket || !this.basket.cartItemGroups) return 0;
            return this.basket.cartItemGroups[0].totalUpFrontPrice;
        },
        minimumPrice() {
            if(!this.basket || !this.basket.cartItemGroups) return 0;
            return this.basket.cartItemGroups[0].subscriptionPeriodMinimumPrice;
        },
        installationAddress() {
            let address = {streetName : '', streetNumber: '', floorNumber: '', floorSide: '', postCode: '', city: ''};
            if(!this.basket || !this.basket.installationAddress) return address;
            if(this.basket.installationAddress.streetName) address.streetName = this.basket.installationAddress.streetName;
            if(this.basket.installationAddress.streetNumber) address.streetNumber = this.basket.installationAddress.streetNumber;
            if(this.basket.installationAddress.floorNumber) address.floorNumber = this.basket.installationAddress.floorNumber;
            if(this.basket.installationAddress.floorSide) address.floorSide = this.basket.installationAddress.floorSide;
            if(this.basket.installationAddress.postCode) address.postCode = this.basket.installationAddress.postCode;
            if(this.basket.installationAddress.city) address.city = this.basket.installationAddress.city;
            return address;
        }

        
    }),
    methods: {
        toggleBasketModal() {
            this.showModal = !this.showModal;
            if (this.showModal) this.preventScrolling();
            else this.enableScrolling();
        },
        enableScrolling() {
            var x = document.getElementsByTagName("BODY")[0];
            x.className = x.className.replace(/\bts-scroll-stop\b/, '');
        },
        preventScrolling() {
            var x = document.getElementsByTagName("BODY")[0];
            x.className += " ts-scroll-stop";
        },
        groupBy: function(xs, key) {
            return xs.reduce(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        groupByArray(xs, key) {
            var groups = this.groupBy(xs, key);
            var array = [];

            for (var key in groups) {
                if (groups.hasOwnProperty(key)) {
                    array.push({ header: key, items: groups[key] });
                }
            }

            return array;
        }
    }
}
